import { eyeSlashIcon } from "../../../core/elements/icons/index.js";
import entryWidget from "./entryWidget.js";

/*
 * I am a concrete implementation of `entryWidget' in the case
 * my model is a `file'.
 *
 * I only override the click action.
 */

/**
 * Todo: Add JSDoc comment
 */
function fileWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = entryWidget(spec, my);

	my.onClickAction = function () {
		my.trigger("fileClicked", that.model());
	};

	my.listIcon = function () {
		return that.model().isPreliminary()
			? eyeSlashIcon.getCssClass()
			: "fa fa-file";
	};

	my.icon = function () {
		return `di-${getFileExtension(that.model().name())}`;
	};

	function getFileExtension(filename) {
		return filename.split(".").pop().toLowerCase();
	}

	return that;
}

export default fileWidget;
